import {FilledClockIcon, Grid, Typography, UnstableCard as Paper} from '@logistics-frontend/blocks'
import React from 'react'

import {Body, Header} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import {DeliveryDateSelect} from '../DeliveryDateSelect/DeliveryDateSelect'
import {DeliveryIntervalSelect} from '../DeliveryIntervalSelect/DeliveryIntervalSelect'
import {DeliveryIntervalDescription} from './DeliveryIntervalDescription/DeliveryIntervalDescription'
import {useNddDeliveryIntervals} from './hooks'

export function DeliveryIntervalsNdd(): React.ReactElement {
  const {isDeliveryIntervalsPending, dateList, intervalList, isDeliveryIntervalsVisible} = useNddDeliveryIntervals()

  return (
    <Paper radius="L">
      <Grid size="l" container>
        <Grid xs={12} item>
          <Header lead={<FilledClockIcon />}>
            <Typography thickness="medium" variant="title4">
              {i18n('ndd.delivery.delivery-policy.title', 'Когда доставить')}
            </Typography>
          </Header>
        </Grid>
        <Grid xs={12} item>
          <Body
            lead={
              <Typography group="tight" mt="s" thickness="medium" variant="body2">
                {i18n('cargo.create.select-delivery-interval.title', 'Интервал')}
              </Typography>
            }
            tail={
              <Grid size="s" container>
                <Grid xs={isDeliveryIntervalsVisible ? 6 : 12} item>
                  <DeliveryDateSelect dates={dateList} isLoading={isDeliveryIntervalsPending} name="ndd.deliveryDate" />
                </Grid>
                {isDeliveryIntervalsVisible && (
                  <>
                    <Grid xs={6} item>
                      <DeliveryIntervalSelect
                        intervals={intervalList}
                        isLoading={isDeliveryIntervalsPending}
                        name="ndd.deliveryInterval"
                      />
                    </Grid>
                    <Grid xs={12} item>
                      <DeliveryIntervalDescription name="ndd.deliveryInterval" />
                    </Grid>
                  </>
                )}
              </Grid>
            }
          />
        </Grid>
      </Grid>
    </Paper>
  )
}
